import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import { initI18n } from 'www/utils'
import LpuSchedule from 'www/vue_components/common/LpuSchedule/components/common/LpuSchedule.vue'
import { MOUNT_SELECTOR } from 'www/vue_components/common/LpuSchedule/constants'
import I18NextVue from 'i18next-vue'

const mountElement = document.querySelector(MOUNT_SELECTOR)

async function mountLpuSchedule() {
  const { i18next } = await initI18n({ bundle: 'vue_components/common/LpuSchedule' })

  Vue.use(I18NextVue, { i18next })

  if (mountElement) {
    new Vue({
      vuetify,
      el: mountElement,
      components: {
        LpuSchedule,
      },
    })
  }
}

mountLpuSchedule()
